import { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import SessionCompletion from 'components/global/SessionCompletion';

const timeStyle = {
  fontSize: '28px',
  fontWeight: '600',
  color: '#b0c6f2',
  letterSpacing: '1.3px',
  fontFamily: 'Barlow',
};

const subtitles = {
  fontSize: '12px',
  color: '#5781be',
  fontWeight: '600',
};

function VideoBar({
  disconnect,
  countdown,
  toggleFullscreen,
  exitFullScreen,
  receivers,
  appointment,
}) {
  const [completeSessionModal, setCompleteSessionModal] = useState(false);
  const [hideTime, setHideTime] = useState(false);

  const toggleModal = () => {
    setCompleteSessionModal(prev => !prev);
  };

  const toggleTimer = () => {
    setHideTime(prev => !prev);
  };

  return (
    <div className="videoBar">
      <div style={{ display: 'inline-block', paddingRight: '40px' }}>
        <h4 style={subtitles}>
          <FormattedMessage defaultMessage="TIME REMAINING" />
        </h4>
        {!hideTime ? (
          <h4 style={timeStyle}>{countdown}</h4>
        ) : (
          // eslint-disable-next-line react/jsx-no-literals
          <h4 style={timeStyle}>- - - - </h4>
        )}
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          className="hide-timer"
          onClick={toggleTimer}
          role="presentation"
        >
          {!hideTime ? (
            <FormattedMessage defaultMessage="Hide Timer" />
          ) : (
            <FormattedMessage defaultMessage="Show Timer" />
          )}
        </a>
      </div>
      <div style={{ marginLeft: '12px', display: 'inline-block' }}>
        <h4 style={subtitles}>
          <FormattedMessage defaultMessage="Client" />
        </h4>
        <h4
          id="nameOfRemote"
          style={{
            ...timeStyle,
            color: 'black',
            fontWeight: ' 300',
            letterSpacing: '0px',
          }}
        >
          {receivers[0] &&
            receivers[0].id &&
            receivers[0].preferred_name_with_last_name}
          {receivers[1] && receivers[1].id && (
            <span>
              <br />
              {receivers[1].full_name}
            </span>
          )}
        </h4>
      </div>
      <div className="button-wrapper" style={{ marginLeft: 'auto' }}>
        <Button
          className="flat-button-white"
          style={{
            marginRight: '10px',
            boxShadow: '0 0 10px 1px rgba(146, 180, 255, 0.2)',
          }}
          onClick={toggleFullscreen}
        >
          {<FormattedMessage defaultMessage="Fullscreen" />}
        </Button>
        <Button
          className="flat-button-green"
          onClick={() => {
            exitFullScreen();
            toggleModal();
          }}
        >
          {<FormattedMessage defaultMessage="Complete Session" />}
        </Button>
      </div>
      {completeSessionModal && (
        <SessionCompletion
          open={completeSessionModal}
          appointmentId={appointment.id}
          handleClose={toggleModal}
          handlePostChange={disconnect}
        />
      )}
    </div>
  );
}

VideoBar.propTypes = {
  disconnect: PropTypes.func.isRequired,
  countdown: PropTypes.string.isRequired,
  toggleFullscreen: PropTypes.func.isRequired,
  exitFullScreen: PropTypes.func.isRequired,
  receivers: PropTypes.array.isRequired,
  appointment: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const appointment = _.get(state, 'session.appointment');
  return {
    appointment,
  };
}

export default connect(mapStateToProps)(VideoBar);
